export function initalizeRolloverCards() {
    const isTouch = window.matchMedia("(hover: none)").matches;
    if (!isTouch) return;

    const cards = document.querySelectorAll(".rollover_card");
    if (!cards.length) return;

    cards.forEach((card) => {
        card.addEventListener("click", function () {
            const isActive = card.classList.contains("is-overlay-active");
            document.querySelectorAll(".rollover_card.is-overlay-active").forEach((c) => c.classList.remove("is-overlay-active"));
            if (isActive) return;
            card.classList.add("is-overlay-active");
        });
    });
}
